import { useState } from 'react';
import { Share2, Link2, Check, Mail, Linkedin, MessageCircle } from 'lucide-react';

const btn = 'btn btn--xs btn--white normal-case';

export const ShareBar = ({ shareUrl, title, compact = false }) => {
  const [copied, setCopied] = useState(false);
  const text = encodeURIComponent(`${title} – gastro-beratung.de Insights`);
  const url = encodeURIComponent(shareUrl);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      window.prompt('Link kopieren:', shareUrl);
    }
  };

  return (
    <div className={`flex flex-wrap items-center gap-3 ${compact ? '' : 'mt-2'}`} data-testid="share-bar">
      {!compact && (
        <span className="inline-flex items-center gap-1.5 label-caps text-ink/70 mr-1">
          <Share2 className="w-4 h-4" />
          Teilen:
        </span>
      )}
      <a href={`https://wa.me/?text=${text}%20${url}`} target="_blank" rel="noopener noreferrer" className={btn} data-testid="share-whatsapp">
        <MessageCircle className="w-4 h-4" />
        WhatsApp
      </a>
      <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`} target="_blank" rel="noopener noreferrer" className={btn} data-testid="share-linkedin">
        <Linkedin className="w-4 h-4" />
        LinkedIn
      </a>
      <a href={`mailto:?subject=${text}&body=${url}`} className={btn} data-testid="share-mail">
        <Mail className="w-4 h-4" />
        E-Mail
      </a>
      <button type="button" onClick={copy} className={btn} data-testid="share-copy">
        {copied ? <Check className="w-4 h-4 text-wa" /> : <Link2 className="w-4 h-4" />}
        {copied ? 'Link kopiert' : 'Link kopieren'}
      </button>
    </div>
  );
};
